import { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { TextStyle } from '@tiptap/extension-text-style';
import { FontFamily } from '@tiptap/extension-font-family';
import { FontSize } from "../FontSize";
import { Color } from "@tiptap/extension-color";
import Highlight from '@tiptap/extension-highlight';
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";

import "./EditorTipTap.css";
import { ColorPalette } from "./ColorPalette";
import { ColorPickerDropdown } from "./ColorPickerDropdown";
import { HighlightPickerDropdown } from "./HighlightPickerDropdown";

export default function EditorTipTap({ value, onChange, editable, className }) {
  const editor = useEditor({
    content: value || "",
    editable,
    extensions: [
      TextStyle,
      StarterKit,
      Underline,
      Link.configure({
        openOnClick: true,
      }),      
      Color.configure({
        types: ['textStyle']
      }),
      FontSize,
      FontFamily.configure({
        types: ['textStyle']
      }),
      Highlight.configure({
        multicolor: true 
      })
    ],
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
  });

  useEffect(() => {
    if (editor) editor.setEditable(editable);
  }, [editable, editor]);

  const addLink = () => {
    const url = prompt("Ingrese URL:");
    if (url) editor.chain().focus().setLink({ href: url }).run();
  };

  return (
    <div className="tiptap-container">
      {!editor && <div>Cargando editor...</div>}

      {editor && editable && (
        <div className="tiptap-toolbar">

          {/* Bold */}
          <button
            className={editor.isActive("bold") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleBold().run()}
          >
            <b>B</b>
          </button>

          {/* Italic */}
          <button
            className={editor.isActive("italic") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleItalic().run()}
          >
            <i>I</i>
          </button>

          {/* Underline */}
          <button
            className={editor.isActive("underline") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleUnderline().run()}
          >
            <u>U</u>
          </button>

          {/* H2 */}
          <button
            className={editor.isActive("heading", { level: 2 }) ? "active" : ""}
            onClick={() =>
              editor.chain().focus().toggleHeading({ level: 2 }).run()
            }
          >
            H2
          </button>

          {/* Color de texto */}
          <ColorPickerDropdown editor={editor} />

          {/* Highlight */}
          <HighlightPickerDropdown editor={editor} />


        {/* Tamaño */}
          <select onChange={(e) => editor.chain().focus().setFontSize(e.target.value).run()}>
            <option value="8px">8</option>
            <option value="10px">10</option>
            <option value="11px">11</option>
            <option value="12px">12</option>
            <option value="13px">13</option>
            <option value="14px">14</option>
            <option value="16px">16</option>
            <option value="18px">18</option>
            <option value="20px">20</option>
            <option value="22px">22</option>
            <option value="24px">24</option>
            <option value="30px">30</option>
          </select>

          {/* Fuente */}
          <select onChange={(e) => editor.chain().focus().setFontFamily(e.target.value).run()}>
            <option value="Arial">Arial</option>
            <option value="Courier New">Courier New</option>
            <option value="Times New Roman">Times New Roman</option>
            <option value="Verdana">Verdana</option>
          </select>          

          {/* Bullet list */}
          <button
            className={editor.isActive("bulletList") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleBulletList().run()}
          >
            • Lista
          </button>

          {/* Ordered list */}
          <button
            className={editor.isActive("orderedList") ? "active" : ""}
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
          >
            1. Lista
          </button>

          {/* Link */}
          <button onClick={addLink}>🔗 Link</button>

          {/* Undo / Redo */}
          <button onClick={() => editor.chain().focus().undo().run()}>⤺ Undo</button>
          <button onClick={() => editor.chain().focus().redo().run()}>⤻ Redo</button>
        </div>
      )}

      <EditorContent
        editor={editor}
        className={`tiptap-editor ${className || ""}`}
      />
    </div>
  );
}
